import { call, put, takeEvery } from 'redux-saga/effects';
import { ISettingsParams } from './types/settings.t';
import { getRequest, putRequest } from '../../app/request';
import { failurePut } from '../../app/failurePut';
import { settingsSlice } from './settingsReducer';

const {
    loadSettingsFailure,
    loadSettingsSuccess,
    updateSettingsAction,
    updateSettingsFailure,
    updateSettingsSuccess,
    loadSettingsAction,
} = settingsSlice.actions;

function* loadSettingsSaga({ payload }: ReturnType<typeof loadSettingsAction>) {
    try {
        const data: ISettingsParams = yield call(getRequest, '/user/settings');
        yield put(loadSettingsSuccess(data));
    } catch (e) {
        yield call<typeof failurePut>(failurePut, e, loadSettingsFailure);
    }
}

function* updateSettingsSaga({ payload }: ReturnType<typeof updateSettingsAction>) {
    try {
        const data: ISettingsParams = yield call(putRequest, '/user/settings', payload);
        yield put(updateSettingsSuccess(data));
    } catch (e) {
        yield call<typeof failurePut>(failurePut, e, updateSettingsFailure);
    }
}

export function* settingsSagas() {
    yield takeEvery(loadSettingsAction, loadSettingsSaga);
    yield takeEvery(updateSettingsAction, updateSettingsSaga);
}
